import { render } from "./ExternalLink.vue?vue&type=template&id=4c3a2554&scoped=true&ts=true"
import script from "./ExternalLink.vue?vue&type=script&lang=ts"
export * from "./ExternalLink.vue?vue&type=script&lang=ts"

import "./ExternalLink.vue?vue&type=style&index=0&id=4c3a2554&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3a2554"]])

export default __exports__